import { useTranslation } from 'react-i18next';
import qrPlayStore from '../../assets/qr-play-store.png';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=org.weavewords.app';

const AndroidQrLink = () => {
    const { t } = useTranslation('auth');

    return (
        <a
            className="auth-android-qr"
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('login.android_app')}
        >
            <img src={qrPlayStore} alt={t('login.android_app')} width="120" height="120" loading="lazy" />
            <span className="auth-android-qr-label">{t('login.android_app')}</span>
        </a>
    );
};

export default AndroidQrLink;
